<script setup>
import { ref, computed, onMounted, watch } from 'vue';
import axios from "axios";
import {Spin, Table, Modal, Input, Tooltip, Button, Select, SelectOption} from 'ant-design-vue';
import {Excel} from "antd-table-saveas-excel";
import BaseCompetitionTourChecker from "@/components/Base/BaseCompetitionTourChecker.vue";

// Состояние компонента
const loading = ref(false);
const pis = ref([]);
const user = ref(null);
const criterias = ref([]);
const searchText = ref('');
const colorFilter = ref('');
const columns_vote = ref([
	{
		title: 'Эксперт',
		dataIndex: 'expert',
		key: 'expert',
	},
	{
		title: 'Оценка',
		dataIndex: 'value',
		key: 'value',
	},
	{
		title: 'Комментарий',
		dataIndex: 'comment',
		key: 'comment',
	},
]);
const competition = ref({});
const tour = ref('');
const categoryId = ref('150');
const showModal = ref(false);
const modalContent = ref('');
const isModalVisible = ref(false);
const currentVotes = ref([]);

// Вычисляемые свойства
const currentUserId = computed(() => {
	return window.currentUserId;
});

const competitionId = computed(() => {
	return window.competitionId;
});

const themes = computed(() => {
	const res = [];
	pis.value.forEach((item) => {
		if (item.project.project_data && item.project.project_data['theme'] !== undefined) {
			res.push(item.project.project_data['theme']);
		}
	});
	return res;
});

const themes_stat = computed(() => {
	let res = {};
	
	themes.value.forEach(item => {
		if (Array.isArray(item)) {
			item.forEach(function (i) {
				// eslint-disable-next-line no-prototype-builtins
				if (res.hasOwnProperty(i)) {
					res[i]++;
				} else {
					res[i] = 1;
				}
			});
		}
	});
	
	return res;
});

const table_columns = computed(() => {
	const res = [];
	res.push({
		title: 'Проект',
		dataIndex: ['project', 'name'],
		key: 'project.name',
		fixed: true
	});
	// res.push({
	//   title: 'Категория',
	//   dataIndex: ['category', 'name'],
	//   key: 'category_name'
	// })
	// res.push({
	//   title: 'Организация',
	//   dataIndex: ['project', 'user', 'user_data', 'organization_name'],
	//   key: 'organization'
	// })
	//
	// res.push({
	//   title: 'Средний балл',
	//   dataIndex: 'avg',
	//   key: 'avg'
	// })
	//
	if (criterias.value[0] && criterias.value[0].criteria) {
		criterias.value[0].criteria.forEach((item, index) => {
			res.push(
				{
					//title: split_string(item.name, 20),
					title: item.name,
					dataIndex: 'scores_' + item.id,
					key: 'scores_' + item.id
				}
			);
		});
	}
	
	res.push({
		title: 'Фаворит',
		dataIndex: 'favorit',
		key: 'favorit',
		sorter: true
	});
	
	res.push({
		title: 'Итого баллов',
		dataIndex: 'total_score',
		key: 'total_score',
		sorter: true
	});
	
	
	
	return res;
});

const excel_columns = computed(() => {
	// Копируем все колонки из table_columns
	const res = [...table_columns.value];
	
	// Добавляем дополнительные колонки только для Excel
	res.push({
		title: 'Режиссеры',
		dataIndex: 'regisers',
		key: 'regisers'
	});
	
	res.push({
		title: 'Компания производитель',
		dataIndex: 'company',
		key: 'company'
	});
	
	res.push({
		title: 'Адрес компании',
		dataIndex: 'company_address',
		key: 'company_address'
	});
	
	return res;
});

const to_excel_row_data = computed(() => {
	let res = [...pis.value];
	
	
	res.forEach((item) => {
		table_columns.value.forEach((column) => {
			if (column.key.startsWith('scores_')) {
				const votes = getVotes(item.newVotes, column.key.replace('scores_', ''));
				let string = '';
				votes.forEach((vote, index) => {
					if (index < votes.length - 1) {
						string += `${vote.expert} - ${vote.value} (${vote.comment}) | `;
					} else {
						string += `${vote.expert} - ${vote.value} (${vote.comment})`;
					}
				});
				item[column.key] = string;
			}
		});
		
		item['favorit'] = item.favorite ? 'Да' : '';
		item['total_score'] = getTotalScore(item.newVotes);
		item['regisers'] = getRegisers(item.project);
		item['company'] = getCompany(item.project);
		item['company_address'] = getCompanyAddress(item.project);
		
	});
	
	return res;
});

function getRegisers(project) {
	if (!project || !project.stage) return '';
	
	const directors = project.stage.filter(member =>
		member.whois === 'regiser' || member.whois === 'regiser2'
	);
	
	if (directors.length === 0) return '';
	
	return directors.map(director =>
		`${director.last_name} ${director.first_name} ${director.patronymic}`
	).join(', ');
}

function getCompany(project) {
	if (!project || !project.user || !project.user.user_data) return '';
	
	return project.user.user_data.organization_name || '';
}

function getCompanyAddress(project) {
	if (!project || !project.user || !project.user.user_data) return '';
	
	const userData = project.user.user_data;
	const addressParts = [];
	
	if (userData.organization_address_country) {
		addressParts.push(userData.organization_address_country);
	}
	
	if (userData.organization_address_region) {
		addressParts.push(userData.organization_address_region);
	}
	
	if (userData.organization_address_city) {
		addressParts.push(userData.organization_address_city);
	}
	
	return addressParts.join(', ');
}

const pis_filtered = computed(() => {
	let res = [];
	
	if (searchText.value.length > 0) {
		res = pis.value.filter((item) => {
			return item.project.name.toLowerCase().indexOf(searchText.value.toLowerCase()) !== -1;
		});
		return res;
	}
	
	if (colorFilter.value === 'red') {
		res = pis.value.filter((item) => {
			return item.hasRed;
		});
		return res;
	}
	if (colorFilter.value === 'yellow') {
		res = pis.value.filter((item) => {
			return item.hasYellow;
		});
		return res;
	}
	
	return pis.value;
});

const stat = computed(() => {
	let organizations = [];
	let countRed = [];
	let countRedYellow = [];
	let countOnlyYellow = [];
	let allGreen = [];
	
	pis.value.forEach(item => {
		organizations.push(item.id);
		
		let hasRed = false;
		let hasYellow = false;
		let hasGreen = false;
		
		table_columns.value.forEach((column) => {
			let val = getSquareClass(column, item);
			if (val === 'red') {
				hasRed = true;
			}
			if (val === 'yellow') {
				hasYellow = true;
			}
			if (val === 'green') {
				hasGreen = true;
			}
		});
		
		if (hasRed) {
			countRed.push(item.id);
		}
		if (hasRed && hasYellow) {
			countRedYellow.push(item.id);
		}
		if (hasYellow) {
			countOnlyYellow.push(item.id);
		}
		if (!hasRed && !hasYellow && hasGreen) {
			if (!allGreen.includes(item.project.user.user_data['organization_name'])) {
				allGreen.push(item.project.user.user_data['organization_name']);
			}
		}
	});
	
	return {
		countOrganizations: organizations.length,
		countRed: countRed.length,
		countRedYellow: countRedYellow.length,
		countOnlyYellow: countOnlyYellow.length,
		countAllGreen: allGreen.length
	};
});

// Методы
function split_string(string, length) {
	if (string.length <= length) {
		return string;
	} else {
		return string.slice(0, length - 3) + '...';
	}
}

function only_numbers(string) {
	return string.match(/^\d+/)[0];
}

async function makeProjectinfoFavorite(projectinfoId) {
	await axios.post('/competition/make_pi_favorit', null, {
		params: {
			pi_id: projectinfoId
		}
	});
}

async function handleTableChange(pagination, filters, sorter) {
	//await getData();
	
	const {field, order} = sorter;
	if (field === 'favorit') {
		if (order === 'ascend') {
			pis.value.sort((a, b) => a.favorit - b.favorit);
		} else {
			pis.value.sort((a, b) => b.favorit - a.favorit);
		}
	} else if (field === 'total_score') {
		if (order === 'ascend') {
			pis.value.sort((a, b) => parseFloat(a.total_score) - parseFloat(b.total_score));
		} else {
			pis.value.sort((a, b) => parseFloat(b.total_score) - parseFloat(a.total_score));
		}
	}
}

async function onShowModal(column, record) {
	const res = await getVotes(record.newVotes, column.key.replace('scores_', ''));
	
	currentVotes.value = res;
	//modalContent = content;
	isModalVisible.value = true;
}

function getSquareClass(column, record) {
	const votes = getVotes(record.newVotes, column.key.replace('scores_', ''));
	if (votes.length > 0) {
		let res = 'green';
		if (column.key === 'scores_154' || column.key === 'scores_176') {
			votes.forEach((vote) => {
				if (vote.value === 'Имеются замечания') {
					res = 'red';
				} else if (vote.value === 'Да' && res !== 'red') {
					res = 'yellow';
				}
			});
			return res;
		}
		
		votes.forEach((vote) => {
			if (vote.value === 'Нет') {
				res = 'red';
			} else if (vote.value === 'Имеются замечания' && res !== 'red') {
				res = 'yellow';
			}
		});
		return res;
	} else {
		return 'gray';
	}
}

function exportToExcel() {
	const excel = new Excel();
	excel
		.addSheet(`Лист1`)
		.addColumns(excel_columns.value)
		.addDataSource(to_excel_row_data.value, {
			str2Percent: true
		})
		.saveAs(`Data.xlsx`);
}

function getVotes(newVotes, criterionId) {
	let res = [];
	newVotes.forEach((newVote) => {
		newVote.newVoteData.forEach((newVoteData) => {
			if (newVoteData.criterion.id == criterionId) {
				res.push({
					expert: newVote.user.fio,
					value: newVoteData.score,
					comment: newVoteData.comment
				});
			}
		});
	});
	
	return res;
}

function getTotalScore(newVotes) {
	// Объект для хранения сумм и количества голосов по каждому критерию
	const criteriaScores = {};
	
	// Собираем оценки по критериям
	newVotes.forEach((newVote) => {
		if (String(newVote.tour) === String(tour.value)) {
			newVote.newVoteData.forEach((newVoteData) => {
				const criterionId = newVoteData.criterion.id;
				// Проверяем, что оценка является числом
				if (!isNaN(parseFloat(newVoteData.score))) {
					if (!criteriaScores[criterionId]) {
						criteriaScores[criterionId] = {
							sum: 0,
							count: 0
						};
					}
					criteriaScores[criterionId].sum += parseFloat(newVoteData.score);
					criteriaScores[criterionId].count += 1;
				}
			});
		}
	});
	
	// Вычисляем среднее по каждому критерию, затем общее среднее
	let totalAverage = 0;
	let criteriaCount = 0;
	
	for (const criterionId in criteriaScores) {
		if (criteriaScores[criterionId].count > 0) {
			// Среднее значение для текущего критерия
			const criterionAverage = criteriaScores[criterionId].sum / criteriaScores[criterionId].count;
			totalAverage += criterionAverage;
			criteriaCount++;
		}
	}
	
	// Среднее значение по всем критериям
	// const finalScore = criteriaCount > 0 ? totalAverage / criteriaCount : 0;
	// return finalScore.toFixed(1);
	return totalAverage.toFixed(1);
}

async function getData() {
	loading.value = true;
	
	const response = await axios.get('/api/competitions/' + competitionId.value);
	competition.value = response.data;
	if (tour.value === '') {
		tour.value = String(competition.value.tour);
	}
	
	
	// if (tour.value.length > 0) {
	//   const items = await axios.get('/competition/get_active_pis/'+competitionId.value+'/'+tour.value);
	//   pis.value = items.data;
	//
	// } else {
	//   const items = await axios.get('/competition/get_active_pis/'+competitionId.value);
	//   pis.value = items.data;
	// }
	
	const user_res = await axios.get('/api/users/' + currentUserId.value + '.json');
	user.value = user_res.data;
	
	const criterias_res = await axios.get('/competition/get_competition_criterias_by_category/' + competitionId.value + '/' + categoryId.value + '/' + tour.value);
	criterias.value = criterias_res.data;
	
	const items = await axios.get('/competition/get_rvvb_pis/' + competitionId.value + '/' + categoryId.value + '/' + tour.value);
	
	items.data.forEach((item) => {
		item.hasRed = false;
		item.hasYellow = false;
		item.hasGreen = false;
		
		table_columns.value.forEach((column) => {
			let val = getSquareClass(column, item);
			if (val === 'red') {
				item.hasRed = true;
			}
			if (val === 'yellow') {
				item.hasYellow = true;
			}
			if (val === 'green') {
				item.hasGreen = true;
			}
		});
		
		item.total_score = getTotalScore(item.newVotes);
	});
	
	pis.value = items.data;
	
	loading.value = false;
}

// Жизненный цикл и наблюдение
onMounted(() => {
	getData();
});

watch(() => tour.value, () => {
	getData();
});
</script>

<template>
	<div v-if="!loading">
		<h3 style="margin-bottom: 40px;">Отчет по конкурсу "{{ competition.name }}"</h3>
		<a class="button4" style="margin-bottom: 20px;" @click="exportToExcel">Экспорт в Excel</a>
		
		<BaseCompetitionTourChecker
			@changeValue="(value) => tour=value"
			:value="tour"
		></BaseCompetitionTourChecker>
		
		
		<div style="margin-bottom: 30px;">
			<div style="margin-bottom: 20px;">
				<div><label>Фильтр по цвету</label></div>
				<Select
					v-model:value="colorFilter"
					:allowClear="true"
					size="middle"
					style="width: 200px"
				>
					<SelectOption value="red">Есть красные</SelectOption>
					<SelectOption value="yellow">Есть желтые</SelectOption>
				</Select>
			</div>
			
			
			<input style="width: 300px" type="text" placeholder="Поиск проекта" v-model="searchText">
		</div>
		
		<div>
			<p>Заявок - {{ stat.countOrganizations }}</p>
			<p>С красными ответами - {{ stat.countRed }}</p>
			<p>с красными и желтыми - {{ stat.countRedYellow }}</p>
			<p>с желтыми - {{ stat.countOnlyYellow }}</p>
			<p>всеми зелеными полями - {{ stat.countAllGreen }}</p>
		</div>
		
		<div class="items">
			<div class="item" v-for="item in competition.categories" :key="item.id" :class="categoryId == item.id ? 'active' : ''" @click="categoryId = item.id; getData();">
				{{ item.name }}
			</div>
		</div>
		
		<div id="table_container" style="overflow-x: auto; height:650px" ref="tableContainer">
			<Table
				:columns="table_columns"
				:data-source="pis_filtered"
				@change="handleTableChange"
			>
				<template #headerCell="{ title, column }">
					<template v-if="column.key.startsWith('scores_')">
						<div>
							<Tooltip :title="title">{{ only_numbers(title) }}</Tooltip>
						</div>
					</template>
					<template v-else>
					
					</template>
				
				</template>
				<template #bodyCell="{ column, record }">
					<template v-if="column.key.startsWith('scores_')">
						<div class="square" :class="getSquareClass(column, record)"
						     @click="onShowModal(column, record)"></div>
					</template>
					
					<template v-if="column.key === 'project.name'">
						
						<Tooltip :title="record.project.user.user_data.organization_name">{{ record.project.name }}</Tooltip>
					</template>
					
					<template v-if="column.key === 'favorit'">
						<div style="display: flex; justify-content: center">
							<input @click="makeProjectinfoFavorite(record.id)" :data-pid="record.id" type="checkbox"
							       name="myCheckbox" :checked="record.favorite">
						</div>
					</template>
				
				</template>
			
			</Table>
		</div>
		
		
		<p style="margin-top: 50px;">Темы проектов</p>
		<div>
			<ul>
				<li v-for="(item, key) in themes_stat" :key="key">{{ key }} - {{ item }}</li>
			</ul>
		</div>
		
		<Modal
			v-model:visible="isModalVisible"
			:footer="null"
		>
			<Table
				:columns="columns_vote"
				:data-source="currentVotes"
			></Table>
		</Modal>
	</div>
	<div v-else>
		<Spin></Spin>
	</div>
</template>

<style scoped>
.topscroll {
	position: absolute;
	width: 1000px;
	height: 20px;
	overflow-x: scroll;
	z-index: 111;
}

.fake {
	height: 1px;
}

.square {
	width: 35px;
	height: 35px;
	background: #cccccc;
	cursor: pointer;
}

.square.green {
	background: green;
}

.square.yellow {
	background: yellow;
}

.square.red {
	background: red;
}

.items {
	display: flex;
}

.items .item {
	margin-bottom: 35px;
	margin-right: 20px;
	cursor: pointer;
}

.items .item.active {
	border-bottom: 4px solid #F69400;
	padding-bottom: 10px;
}
</style>